module.exports = __webpack_public_path__ + "img/location-image.ba4a24f1.png";